// const devBaseURL = "https://27.195.117.21";
// const proBaseURL = "https://27.195.117.21";

const devBaseURL = window.location.origin;
const proBaseURL = window.location.origin;

// const devBaseURL = "http://221.0.95.158:41365";
// const proBaseURL = "http://221.0.95.158:41365";

// const devBaseURL = "https://www.zbsnyjt.com";
// const proBaseURL = "https://www.zbsnyjt.com";

// const devBaseURL = "http://10.60.112.45:41365";
// const proBaseURL = "http://10.60.112.45:41365";

export const BASE_URL =
  process.env.NODE_ENV === "development" ? devBaseURL : proBaseURL;
export const TIMEOUT = 10000;
